<template lang="pug">
  DefaultLayout
    ProjectList2
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import ProjectList2 from '../components/ProjectList2.vue';

export default {
  name: 'ProjectsPage',
  components: { DefaultLayout, ProjectList2 },
};
</script>
